import React, { useState } from "react";
import { Row, Space } from "@masterteam/mt-design-react";

import { ReactComponent as ArrowDown } from "../../assets/images/arrow-down-curve.svg";

import "./style.scss";

function Collapse({
  title = null,
  icon = null,
  defaultExpanded,
  hideCollapse,
  children,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded || false);

  function toggleExpand() {
    setExpanded(!expanded);
  }

  return (
    <div className="collapse-container">
      <Row
        className="collapse-container__title-container"
        align="center"
        justify="between"
      >
        <Space align="center" size="medium">
          {icon && (
            <div className={`collapse-container__title-container__icon`}>
              {icon}
            </div>
          )}
          <div className={`collapse-container__title-container__title`}>
            {title}
          </div>
        </Space>
        {hideCollapse ? null : (
          <div
            onClick={toggleExpand}
            className={`collapse-container__title-container__arrow-icon cursor ${
              expanded &&
              " collapse-container__title-container__arrow-icon--expanded"
            }`}
          >
            <ArrowDown style={{ fill: "var(--primary-color)" }} />
          </div>
        )}
      </Row>
      {expanded && (
        <div className="collapse-container__content-container">{children}</div>
      )}
    </div>
  );
}

export default Collapse;
